module.exports = __webpack_public_path__ + "static/media/desktop-npm.9b4ea6c4.png";